import { inject } from '@angular/core';
import { CanMatchFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

export function userGroupsGuard(
  requiredGroups: readonly string[],
  redirectTo: string[] = ['/home']
): CanMatchFn {
  return () => {
    const auth = inject(AuthService);
    const router = inject(Router);

    if (!requiredGroups.length) {
      return router.createUrlTree(redirectTo);
    }

    return auth.hasAnyUserGroup(requiredGroups)
      ? true
      : router.createUrlTree(redirectTo);
  };
}
